export enum SampleScore {
    noScore = 0,
    sufficient = 1,
    insufficient = 2,
    inapplicable = 3,
}
